import React, { useRef, useState, useCallback, useEffect, useContext } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — routes module resolved by webpack alias
import { manageWorkflowStatusPath, techniciansPath, technicianDayOffsPath, calendarSettingsPath } from '@routes';
import { CalendarContext } from '../../CalendarContext';
const namespace = 'features.calendar.header.view';
function View() {
    const { state: { detailed }, actions: { onChangeView }, permissions } = useContext(CalendarContext);
    const anchor = useRef(null);
    const popup = useRef(null);
    const [open, setOpen] = useState(false);
    const printAction = () => window.print();
    const handleBodyClick = useCallback((event) => {
        var _a, _b, _c;
        // eslint-disable-next-line no-underscore-dangle
        if ((_b = (_a = popup.current) === null || _a === void 0 ? void 0 : _a._popup) === null || _b === void 0 ? void 0 : _b.contains(event.target))
            return;
        if ((_c = anchor.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))
            return;
        setOpen(false);
    }, []);
    useEffect(() => {
        document.body.addEventListener('click', handleBodyClick);
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, [handleBodyClick]);
    const onAddEventPopup = useCallback(() => {
        setOpen(!open);
    }, [open]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "aria-label": "Settings", title: "Settings", ref: anchor, onClick: onAddEventPopup },
            React.createElement("i", { className: "fa-light fa-gear" })),
        React.createElement(Popup, { anchor: anchor.current, show: open, ref: popup },
            React.createElement("div", { className: "qmb-popup--actions" },
                React.createElement("div", { className: "popup__section--group--y-fill" },
                    React.createElement("h4", { className: "popup__title--group" }, translate('display', { namespace })),
                    React.createElement("ul", { role: "presentation" },
                        React.createElement("li", { key: "detailed" },
                            React.createElement("label", { className: "qmb-radio" },
                                React.createElement("input", { type: "radio", id: "display-detailed", onChange: onChangeView, checked: detailed }),
                                React.createElement("i", { className: "fa-light fa-grid-2" }),
                                translate('detailed', { namespace }))),
                        React.createElement("li", { key: "compact" },
                            React.createElement("label", { className: "qmb-radio" },
                                React.createElement("input", { type: "radio", id: "display-compact", onChange: onChangeView, checked: !detailed }),
                                React.createElement("i", { className: "fa-light fa-line-columns" }),
                                translate('compact', { namespace }))))),
                (permissions.techs || permissions.techs_time_offs || permissions.statuses) && (React.createElement(React.Fragment, null,
                    React.createElement("hr", { className: "popup__split" }),
                    React.createElement("div", { className: "popup__section--group" },
                        permissions.techs && (React.createElement("a", { href: techniciansPath(), className: "qmb-control" }, translate('manage_techs', { namespace }))),
                        permissions.techs_time_offs && (React.createElement("a", { href: technicianDayOffsPath(), className: "qmb-control" }, translate('manage_techs_time_offs', { namespace }))),
                        permissions.statuses && (React.createElement("a", { href: manageWorkflowStatusPath(), className: "qmb-control" }, translate('manage_workflow_statuses', { namespace })))))),
                permissions.settings && (React.createElement(React.Fragment, null,
                    React.createElement("hr", { className: "popup__split" }),
                    React.createElement("div", { className: "popup__section--group" },
                        React.createElement("a", { href: calendarSettingsPath(), className: "qmb-control" }, translate('settings', { namespace })),
                        React.createElement("button", { type: "button", onClick: printAction, className: "qmb-control" }, translate('print', { namespace })))))))));
}
export default View;
